import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import reportWebVitals from './reportWebVitals';
import App from "./components/app/App";
import {Provider} from "react-redux";
import {store} from "./store/store";
import {BrowserRouter} from "react-router-dom";
import {CssBaseline, ThemeProvider} from "@mui/material";
import theme from "./util/theme";
import KeycloakService from "./config/keycloak";
import {TolgeeProvider} from "@tolgee/react";
import {tolgee} from "./config/tolgee";

const root = ReactDOM.createRoot(document.getElementById('root'));
const renderApp = () => root.render(
  <Provider store={store}>
      <BrowserRouter future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
      }}>
          <TolgeeProvider tolgee={tolgee} >
              <ThemeProvider theme={theme}>
                  <CssBaseline/>
                  <App />
              </ThemeProvider>
          </TolgeeProvider>
      </BrowserRouter>
  </Provider>
);

// renderApp();

KeycloakService.initKeycloak(renderApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
